import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView, trackEvent } from "@/lib/analytics";

/**
 * Mount once inside <BrowserRouter>. Initializes providers, tracks page views
 * on every route change, and delegates any [data-track] clicks to trackEvent
 * so pages can instrument CTAs declaratively:
 *   <a data-track="cta_click" data-track-label="get_the_book" data-track-location="home_hero">
 */
export default function Analytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();

    const onClick = (e) => {
      const el = e.target.closest("[data-track]");
      if (!el) return;
      const name = el.getAttribute("data-track") || "cta_click";
      const params = {};
      for (const attr of el.attributes) {
        if (attr.name.startsWith("data-track-") && attr.name !== "data-track") {
          params[attr.name.slice("data-track-".length)] = attr.value;
        }
      }
      trackEvent(name, params);
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
